import { useMutation } from 'react-query';
import { validateCardNumber } from 'src/services/api/utils';

function useValidateCardNumber() {
  return useMutation((data) => validateCardNumber(data));
}

export default useValidateCardNumber;